// FeedbackSchema.ts

import { z } from "zod";

/* ----------------------- RAW DATA RETURNED BY WIDGET ---------------------- */
export const FeedbackDataSchema = z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("text"), value: z.string() }),
    z.object({ kind: z.literal("single-select"), value: z.string() }),
    z.object({ kind: z.literal("multi-select"), value: z.array(z.string()) }),
    z.object({ kind: z.literal("number"), value: z.number() }),
    z.object({ kind: z.literal("boolean"), value: z.boolean() }),
    z.object({ kind: z.literal("blob"), value: z.unknown() }),
]);

/* --------------------------- WIDGET-FEEDBACK-OBJ -------------------------- */
export const FeedbackEntrySchema = z.object({
    data: FeedbackDataSchema.nullable(), // -----`null` = untouched / cleared
    valid: z.boolean(), // -----updated by local component whenever validity changes
    message: z.string().optional(), // -----ux-text (error etc.)
    touched: z.boolean().default(false), // -----if changed from original value (null)
});

/* ------------------------------ FEEDBACK-OBJ ------------------------------ */
export const FeedbackSliceSchema = z.record(z.string(), FeedbackEntrySchema);

export type FeedbackEntry = z.infer<typeof FeedbackEntrySchema>;
export type FeedbackSlice = z.infer<typeof FeedbackSliceSchema>;
export type FeedbackData = z.infer<typeof FeedbackDataSchema>;
